import { render, staticRenderFns } from "./DocumentDetailCreateEdit3.vue?vue&type=template&id=4f575820"
import script from "./DocumentDetailCreateEdit3.vue?vue&type=script&lang=js"
export * from "./DocumentDetailCreateEdit3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports